import vuexStore from '@/vuex-store';
import { i18n } from '@/locales';
import { deliveryChargeTypeName } from '@/constants/storeManagement/deliveryChargeDialog';
import { greaterThanTargetNumber, isRequired, isRequiredZeroAvailable, } from './index';
/** 배달대행료 유효성 검사 룰 */
// eslint-disable-next-line import/prefer-default-export
export const createDeliveryChargeFormRule = () => ({
    /** 도착지(지명) */
    specialArea: [
        (v) => {
            if (vuexStore.state.deliveryChargeDialog.formData.type !== deliveryChargeTypeName.LOT_NUMBER_ADDRESS) {
                return true;
            }
            return isRequired(v) || i18n.t('form_rules.value_require');
        },
    ],
    /** 대행료 */
    charge: [
        (v) => isRequiredZeroAvailable(v) || i18n.t('form_rules.value_require'),
    ],
    /** 할증배달대행료 */
    surcharge: [
        (v) => isRequiredZeroAvailable(v) || i18n.t('form_rules.value_require'),
    ],
    distanceStart: [
        (v) => isRequiredZeroAvailable(v) || i18n.t('form_rules.value_require'),
    ],
    distanceEnd: [
        (v) => isRequiredZeroAvailable(v) || i18n.t('form_rules.value_require'),
    ],
    // 다른 값 채크해서 유효성 검사 처리할 때 참조
    distanceOrder: (v) => [
        () => !v,
    ],
    addressJibunStart: [
        (v) => isRequiredZeroAvailable(v) || i18n.t('form_rules.value_require'),
        (v) => greaterThanTargetNumber(v, 0) || i18n.t('form_rules.greater_than_target_value', [
            0,
        ]),
    ],
    addressJibunEnd: [
        (v) => isRequiredZeroAvailable(v) || i18n.t('form_rules.value_require'),
        (v) => greaterThanTargetNumber(v, 0) || i18n.t('form_rules.greater_than_target_value', [
            0,
        ]),
    ],
    addressJibunOrder: (v) => [
        () => !v,
    ],
    areaName: [
        (v) => isRequired(v) || i18n.t('form_rules.value_require'),
    ],
    workingDay: [
        (v) => v.length > 0 || i18n.t('form_rules.value_require'),
    ],
});
